import { render, staticRenderFns } from "./ProjectPlan.vue?vue&type=template&id=7c5870b8&scoped=true&"
import script from "@/views/Groups/Tabs/ProjectPlan.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/ProjectPlan.ts?vue&type=script&lang=ts&"
import style0 from "./ProjectPlan.vue?vue&type=style&index=0&id=7c5870b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5870b8",
  null
  
)

export default component.exports